<template>
  <div class="fengyou" :style="{ backgroundColor: bgColor }">
    <!-- 状态栏   -->
    <status-bar></status-bar>
    <!-- 导航栏 -->
    <activity-nav :backFn="_back"></activity-nav>

    <div v-if="h5ConfigDetails" class="content" :style="`height: calc(100vh - 4.2rem - ${statusBarHeight}${isInIos ? 'px' : 'vh'});`">
      <img :src="`${baseUrl.portalImg}${h5ConfigImgPath}/${h5ConfigDetails[0]['fengyou']['introPic'][$route.query.target]}`" alt="">
    </div>
  </div>
</template>

<script>
import StatusBar from '@/components/navigation/StatusBar'
import ActivityNav from '@/components/navigation/ActivityNav'
import { mapState } from 'vuex'
import { baseUrl } from '@/config/env'

export default {
  name: 'FengyouIntro',
  data () {
    return {
      baseUrl,
      // portal注入的图片及文案信息
      bgColor: '#fff'
    }
  },
  components: {
    StatusBar, ActivityNav
  },
  computed: {
    ...mapState(['statusBarHeight', 'isInIos', 'h5ConfigDetails', 'h5ConfigImgPath'])
  },
  methods: {
    _back () {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="less" scoped>
  .content {
    overflow-y: scroll;
    img {
      width: 100%;
    }
  }
</style>